/* file description */
import { useEffect, useState } from 'react';
import { UseGetLabelByEdit } from './type';

export const useGetLabelByEdit: UseGetLabelByEdit = ({ value, field, form, config, columnFrom, setInputLabel, API, tableData }) => {
  useEffect(() => {
    if (value && tableData?.length > 0) {
      const findDictItem = tableData?.find((item: Record<any, any>) => item[field?.options?.value] === value) || {};
      // 初始化回显值
      setInputLabel(field, findDictItem[field?.options?.label], value);
    }
  }, [tableData, value]);
};
